import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { EDIT } from "const"
import { timezones, hasAccess } from "client/utils"
import {
    mtAccountsRoute,
    mtAccountRoute,
} from "client/parts/routes"
import {
    PRM_ACCOUNT,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    DivInput,
    Button,
    DateFormatter,
} from "client/components"


const Form = () => {
    const account = useSelector((state: StoreType) => state.account.accountView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = userData.accountId === 1
        ? `${mtAccountsRoute}/${EDIT}/${account.id}`
        : `${mtAccountRoute}/${EDIT}`
    const timezone = timezones[account.timezone] || account.timezone

    const editAccess = hasAccess(PRM_ACCOUNT, EDIT)
    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={account.logo || Images.accountLogo} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12} md={8}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={account.name} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={4}>
                            <FormGroup>
                                <Label>{lang.shortName}</Label>
                                <Input type="text" value={account.shortName} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.url}</Label>
                                <Input type="text" value={account.url} readOnly />
                            </FormGroup>
                            {
                                account.demoExpiry
                                && (
                                    <FormGroup>
                                        <Label>{lang.demoExpired}</Label>
                                        <DivInput widePadding>
                                            <DateFormatter date={account.demoExpiry} defaultStyles />
                                        </DivInput>
                                    </FormGroup>
                                )
                            }
                            <FormGroup>
                                <Label>{lang.timezone}</Label>
                                <Input type="text" value={timezone || ""} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.status}</Label>
                                <Input type="text" value={lang[account.status]} readOnly />
                            </FormGroup>
                        </Col>
                        {
                            editAccess
                            && (
                                <Col xs={12}>
                                    <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                        {lang.edit}
                                    </Button>
                                </Col>
                            )
                        }
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
